import React, { type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';

import { Box, Typography } from '@myn/mui';

type Props = {
  search: string;
};

const VersionsPageNoContent: FC<Props> = ({ search }) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box>
        <Illustration className="size-40" component="IllustrationNoResults" />
        <Typography variant="h4" color="text.primary" textAlign="center">
          {t('No results for {{search}}', { search })}
        </Typography>
      </Box>
    </Box>
  );
};

export default VersionsPageNoContent;
